export default __webpack_public_path__ + "static/media/location_preview_jeweled_jungle.840e86a9.svg";